import request from '../utils/request';

//获取用户是否已经领取免费实例
export async function isUsedFreeDevice (params: object = {}) {
  return request(`/api/bill/device/is_used_free_device`, {
    method: 'POST',
    requestType: 'form',
    data: params
  })
}
// 领取免费实例
export  async function getActive(params:object = {}) {
  return request(`/api/bill/device/free_device`, {
    method: 'POST',
    requestType: 'form',
    data: params
  })
}
